module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-756-retro-min.e3e041f9.jpg";